import { render, staticRenderFns } from "./investigationDetail.vue?vue&type=template&id=0c40ddaa"
import script from "./investigationDetail.ts?vue&type=script&lang=js&external"
export * from "./investigationDetail.ts?vue&type=script&lang=js&external"
import style0 from "./investigationDetail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports